<template>
  <dv-border-box-4 :color="dataVThem.color" :backgroundColor="dataVThem.bgColor" class="nav_left">
    <div class="ZuoFenLeiContainer">
      <div class="nav_tit" @click="() => $emit('fenleiClick')">
        分类
        <dv-decoration-2 style="width:100%;height:5px;" />
      </div>
      <div class="nav_items">
        <div class="nav_item txt-cut2" :key="index" v-for="(item, index) in data" @click="() => $emit('dataClick', item)">
          <div class="nav_line txt-cut2">
            {{ item.class_name }}
          </div>
        </div>
      </div>
    </div>
  </dv-border-box-4>
</template>
<script>
export default {
  props: {
    data: {
      types: Array,
      required: true
    }
  },
  created() {
    console.info(this);
    window.debugVue = this;
  },
  methods: {

  }
}
</script>
<style lang="less" scoped>
@import url('~@/assets/style/var.less');
.ZuoFenLeiContainer{
  padding: 1.5rem;
}
.nav_tit {
  font-weight: 700;
  font-size: 18px;
  height: 32px;
  line-height: 32px;
  color: #292929;
  color: @txt-color;
  margin-bottom: 1.5rem;
}

.nav_items::-webkit-scrollbar {
  display: none;
}

.nav_items {
  width: 100%;
  height: 390px;
  overflow-y: auto;
  flex-direction: column;

  .nav_item {
    width: 100%;
    font-weight: 400;
    font-size: 14px;
    color: #292929;
    line-height: 40px;
    height: 40px;
    text-align: center;
    color: @txt-color;
    margin-bottom: 0.5rem;
    box-sizing: border-box;
    border: 1px solid #fff;

    border-color: @border-color;

    .nav_line {
      // display: inline-block;
      padding: 0 15px;
      // line-height: 40px;
      // height: 40px;
    }

    .nav_line:hover {
      border-bottom: 2px solid #fff;

      border-color: @border-color;
      // color: #FF4444;
    }

  }

}
</style>


// WEBPACK FOOTER //
// src/views/home/components/ZuoFenLei.vue